import { CreateTagButton } from "../tags/CreateTagButton";
import { Check } from "lucide-react";
import { useGetList } from "ra-core";
import { useFormContext } from "react-hook-form";

import { Badge } from "@/components/ui/badge";

import type { Company, Tag } from "../types";

import { COMPANY_TAG_GROUPS, normalizeTagName } from "./companyTagGroups";

export const CompanyTagsInput = () => {
  const { watch, setValue } = useFormContext<Company>();

  const { data: tags = [] } = useGetList<Tag>("tags", {
    pagination: {
      page: 1,
      perPage: 100,
    },
    sort: {
      field: "name",
      order: "ASC",
    },
  });

  const selectedIds = watch("tags") ?? [];

  const toggleTag = (id: number) => {
    const selected = selectedIds.includes(id);

    const next = selected
      ? selectedIds.filter((tagId) => tagId !== id)
      : [...selectedIds, id];

    setValue("tags", next, {
      shouldDirty: true,
    });
  };

  const groups = [
    ...COMPANY_TAG_GROUPS,
    {
      key: "custom",
      title: "Другие",
      names: tags
        .filter(
          (tag) =>
            !COMPANY_TAG_GROUPS.some((group) =>
              group.names.some(
                (name) => normalizeTagName(name) === normalizeTagName(tag.name),
              ),
            ),
        )
        .map((tag) => tag.name),
    },
  ];
  return (
    <div className="flex flex-col gap-4">
      <CreateTagButton
        onCreated={(tag) =>
          setValue("tags", [...new Set([...(watch("tags") ?? []), tag.id])], {
            shouldDirty: true,
          })
        }
      />
      <div>
        <h6 className="text-lg font-semibold">Роли и специализация</h6>

        <p className="mt-1 text-sm text-muted-foreground">
          У компании может быть несколько ролей одновременно
        </p>
      </div>

      {groups.map((group) => {
        const groupTags = tags.filter((tag) =>
          group.names.some(
            (name) => normalizeTagName(name) === normalizeTagName(tag.name),
          ),
        );

        if (groupTags.length === 0) {
          return null;
        }

        return (
          <div key={group.key}>
            <div className="mb-2 text-xs font-medium text-muted-foreground">
              {group.title}
            </div>

            <div className="flex flex-wrap gap-2">
              {groupTags.map((tag) => {
                const selected = selectedIds.includes(tag.id);

                return (
                  <button
                    data-mobile-control="compact"
                    key={tag.id}
                    type="button"
                    onClick={() => toggleTag(tag.id)}
                    className={[
                      "rounded-full transition-all",
                      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
                      selected
                        ? "ring-2 ring-foreground/20"
                        : "opacity-75 hover:opacity-100",
                    ].join(" ")}
                  >
                    <Badge
                      variant="secondary"
                      className="cursor-pointer gap-1.5 px-2.5 py-1 text-sm font-normal rovero-colored-tag text-[#482719]"
                      style={{
                        backgroundColor: tag.color,
                      }}
                    >
                      {selected && <Check className="h-3.5 w-3.5" />}

                      {tag.name}
                    </Badge>
                  </button>
                );
              })}
            </div>
          </div>
        );
      })}

      {tags.length === 0 && (
        <div className="text-sm text-muted-foreground">
          Теги пока не созданы.
        </div>
      )}
    </div>
  );
};
